<template>
  <base-wrapper :loading="loading">
    <div class="space-y-4">
      <base-card title="Import Saldo">
        <form class="space-y-4" @submit.prevent="onProcess">
          <base-input label="Pilih Saldo">
            <base-select
              :shadow="false"
              expand
              :options="[
                {
                  key: 'order_balance',
                  label: 'Stockist',
                  value: 'order_balance',
                },
                {
                  key: 'order_debt_balance',
                  label: 'Kurang Bayar Stockist',
                  value: 'order_debt_balance',
                },
                {
                  key: 'restock_balance',
                  label: 'Restock',
                  value: 'restock_balance',
                },
                {
                  key: 'deposit_balance',
                  label: 'Deposit',
                  value: 'deposit_balance',
                },
                {
                  key: 'overpayment_balance',
                  label: 'Sisa Bayar',
                  value: 'overpayment_balance',
                },
                {
                  key: 'debt_balance',
                  label: 'Kurang Bayar SC',
                  value: 'debt_balance',
                },
              ]"
              v-model="type"
            />
          </base-input>
          <base-button type="submit" :loading="loadingProcess.visible">{{
            loadingProcess.visible ? loadingProcessLabel : 'Proses'
          }}</base-button>
        </form>
      </base-card>
    </div>
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapGetters, mapActions } from 'vuex';
import { downloadFileUrl } from '../../../../services/utils.service';

export default {
  mixins: [requestMixin],
  data() {
    return {
      type: 'order_balance',
      loadingPage: false,
      loadingProcess: {
        visible: false,
        text: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      me: 'auth/getUser',
      getChannelName: 'auth/getChannelName',
    }),
    loading() {
      return this.loadingPage;
    },
    loadingProcessLabel() {
      return {
        wait: 'Mengirim Data',
        queued: 'Menunggu Diproses',
        processing: 'Sedang Diproses',
      }[this.loadingProcess.text];
    },
    typeKey() {
      return {
        restock_balance: 'restock',
        deposit_balance: 'deposit',
        overpayment_balance: 'sisabayar',
        debt_balance: 'kurangbayar',
      }[this.type];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    addListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      userChannel.bind(
        'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
        this.onProgress
      );
    },
    async loadJobStatus() {
      this.loadingPage = true;

      const [res, err] = await this.request(
        '/api/v1/users/-actions/check-job-status',
        {
          params: {
            type: 'export_office_balance',
          },
        }
      );

      if (!err) {
        const { running, status } = res;

        if (running) {
          this.startLoadingProcess(status);
        }
      }

      this.loadingPage = false;
    },
    onProgress(e) {
      if (e.type === 'App\\Notifications\\OfficeBalanceExportStatusUpdated') {
        if (e.status === 'processing') {
          this.startLoadingProcess('processing');
        } else if (e.status === 'failed') {
          this.stopLoadingProcess();

          this.createAlert({
            status: 'error',
            data: e.message,
          });
        } else if (e.status === 'finished') {
          this.stopLoadingProcess();

          this.createAlert({
            status: 'success',
            data: 'Berhasil mengexport saldo',
          });

          downloadFileUrl(e.file_url);
        }
      }
    },
    async onProcess() {
      this.startLoadingProcess('wait');

      const [, err] = await this.request(
        '/api/v1/offices/-actions/export-balance',
        {
          method: 'post',
          data: {
            type: this.type,
          },
        }
      );

      if (!err) {
        this.startLoadingProcess('queued');
      } else {
        this.stopLoadingProcess();

        this.createAlert({
          status: 'error',
          data: this.getRequestErrorMessage(err),
        });
      }
    },
    removeListener() {
      const userChannel = this.$pusher.channel(this.getChannelName);

      if (userChannel) {
        userChannel.unbind(
          'Illuminate\\Notifications\\Events\\BroadcastNotificationCreated',
          this.onProgress
        );
      }
    },
    startLoadingProcess(text) {
      this.loadingProcess.text = text;
      this.loadingProcess.visible = true;
    },
    stopLoadingProcess() {
      this.loadingProcess.visible = false;
    },
  },
  created() {
    this.loadJobStatus();
    this.addListener();
  },
  beforeRouteLeave(to, from, next) {
    this.removeListener();
    next();
  },
};
</script>
